import { Component } from '@angular/core'
import { AsmComponentService, AsmMainUiComponent } from '@spartacus/asm/components'
import { AsmService } from '@spartacus/asm/core'
import { AsmUi } from '@spartacus/asm/root';
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  WindowRef
} from '@spartacus/core'
import {LaunchDialogService} from "@spartacus/storefront";
import { UserAccountService } from '@spartacus/user/account/core'
import { CookieService } from 'ngx-cookie-service'
import { of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { EbUserIdService } from '../../../auth/services/eb-user-id.service'
import { EbCsagentAuthService } from '../../services/eb-csagent-auth.service'

@Component({
    selector: 'eb-asm-main-ui',
    templateUrl: './eb-asm-main-ui.component.html',
    styleUrls: ['./eb-asm-main-ui.component.scss'],
    standalone: false
})
export class EbAsmMainUiComponent extends AsmMainUiComponent {
  isUserEmulated$ = this.userIdService.isEmulated()

  constructor(
    protected authService: AuthService,
    protected csAgentAuthService: EbCsagentAuthService,
    protected userAccountService: UserAccountService,
    protected asmComponentService: AsmComponentService,
    protected globalMessageService: GlobalMessageService,
    protected routingService: RoutingService,
    protected asmService: AsmService,
    protected cookieService: CookieService,
    protected userIdService: EbUserIdService,
    protected winRef: WindowRef,
    protected launchDialogService: LaunchDialogService,
  ) {
    super(
      authService,
      csAgentAuthService,
      asmComponentService,
      globalMessageService,
      routingService,
      asmService,
      userAccountService,
      launchDialogService
  )
  }

  ngOnInit() {
    this.customerSupportAgentLoggedIn$ = this.csAgentAuthService.isCustomerSupportAgentLoggedIn()
    this.csAgentTokenLoading$ = this.csAgentAuthService.getCustomerSupportAgentTokenLoading()
    this.customer$ = this.authService.isUserLoggedIn().pipe(
      switchMap(isLoggedIn => {
        if (isLoggedIn) {
          this.handleCustomerSessionStartRedirection()
          return this.userAccountService.get()
        } else {
          return of(undefined)
        }
      })
    )
    this.isCollapsed$ = this.asmService
      .getAsmUiState()
      .pipe(map((uiState: AsmUi) => uiState.collapsed ?? false))
  }

  startCustomerEmulationSession({ customerId }: { customerId?: string }): void {
    if (customerId) {
      this.csAgentAuthService.startCustomerEmulationSession(customerId)
      this.startingCustomerSession = true
    } else {
      this.globalMessageService.add(
        { key: 'asm.error.noCustomerId' },
        GlobalMessageType.MSG_TYPE_ERROR
      )
    }
  }
}
